import { Box, Container } from '@mui/material'
import { EthAddress } from '@xylabs/sdk-js'
import { useContext, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router-dom'

import { MinterEventsContext, MinterEventsLoader } from '../../Contexts'
import { AuctionEventsToolbar } from '../../Toolbar'
import WorldBasePage from '../WorldBasePage'
import EventBox from './EventBox'

const BidderEventsPage: React.FC = () => {
  const { id } = useParams()
  const [bidder] = useState(EthAddress.fromString(id))

  const Loaded: React.FC = () => {
    const { events } = useContext(MinterEventsContext)

    return (
      <Box display="flex" flexDirection="column" padding={1}>
        {events?.map((event, index) => {
          return <EventBox event={event} key={index} />
        })}
      </Box>
    )
  }

  return (
    <MinterEventsLoader account={bidder}>
      <WorldBasePage>
        <Helmet title="Geotoken Auction Events" />
        <Container>
          <Box display="flex" flexDirection="column" minHeight="75vh">
            <AuctionEventsToolbar />
            <Loaded />
          </Box>
        </Container>
      </WorldBasePage>
    </MinterEventsLoader>
  )
}

export default BidderEventsPage
